import Image from 'global/Image';
import { Common, color } from '@stockbit/ui';
import { COMMENT_SETTING_LIST } from 'global/StreamCompose/constants';
import { CommentLimitInfoContainer } from './styled';
import { StreamCommenterType } from '../../../../@types/stream';

const { Text } = Common;

interface CommentLimitInfoProps {
  type: StreamCommenterType;
}

function CommentLimitInfo({ type }: CommentLimitInfoProps) {
  if (type === 'COMMENTER_TYPE_EVERYONE') {
    return null;
  }

  const commentText = COMMENT_SETTING_LIST.find((comment) => comment.type === type);

  return (
    <CommentLimitInfoContainer>
      <Image src="/icon/comment-limit.svg" alt="Comment Limit" width="24px" height="24px" />
      <div>
        <Text
          size="12px"
          color={color.highgray}
          family="bold"
          height="16px"
        >
          Comments Limited
        </Text>
        <Text
          size="12px"
          color={color.highgray}
          height="16px"
        >
          {commentText.label}
        </Text>
      </div>
    </CommentLimitInfoContainer>
  );
}

export default CommentLimitInfo;
